export class SignUp {
  name?: string = '';
  email?: string = '';
  mobileNo?: any = null;
  password?: string = '';
  confirmPassword?: string = '';
  productKey?: string = '';
}

export class Login {
  userName?: string = '';
  password?: string = '';
  authorizationCode?: string = '';
  captchaToken?: string = '';
  langPref?: string = '';
}

export class ScreentimeDto {
  dailyScreenTime?: number = 0;
  deviceId?: string | null = '';
  isEnable: boolean = true;
  lockOnTimeOut: boolean = false;
}

export class Otp {
  otpNo?: string = '';
  otpType?: string = '';
  otpChar?: string = '';
  userName?: string = '';
  randomUid?: any = '';
}

export class ForGotPassword {
  userName?: any;
  email?: any;
  otpType?: string = '';
  captchaToken?: string = '';
  langPref?: string = '';
}

export class ResetOrChangePassword {
  otpId?: any;
  password?: any;
  newPassword?: any;
}

export class MyAccountDto {
  id?: any;
  name?: any;
  lastName?: any;
  dateOfBirth?: any;
  age?: any;
  gender?: any;
  avatarUrl?: any;
  userName?: any = null;
  countryCode?: any = null;
  email?: any = null;
  assignedUserStatus?: any = null;
  mobileNo?: any = null;
  role?: any = null;
  isMobileNoVerified?: boolean = false;
}

export class MyaccountMobileOrEmailDto {
  otpNo?: any;
  otpType?: any;
  otpChar?: any;
  assignedUserStatus?: any;
  userId: any;
}

export class LocationDto {
  latitude?: any;
  longitude?: any;
  locationName?: any;
  id?: any;
}

export class TransferOwnershipDto {
  currentUserId?: any;
  deviceIdList?: any;
  assignedUserId?: any;
}

export class AddUserDto {
  masterKey?: any;
  deviceName?: any;
  deviceType?: any;
  productKeyOrDeviceId?: any;
  otp?: any;
  isResendOTP?: boolean = false;
  productKeyType?: any;
  captchaToken?: any;
  otpChar?: any;
}

export class RemoveDeviceDto {
  productKeyOrDeviceId?: string = '';
  productKeyType?: string = '';
  deactivate?: boolean = false;
}

export class CreateNewPasswordFromLinkDto {
  id?: any;
  password?: any;
  confirmPassword?: any;
  acceptTerms?: any;
}

export class ChangePinDto {
  deviceId?: string = '';
  pin?: string = '';
  confirmPin?: string = '';
  status?: string = '';
}

export class SecurityFeatureDto {
  deviceId?: string = '';
  privacyAdvisor?: boolean = false;
  intruder?: boolean = false;
  playStoreAppAdvisor?: boolean = false;
  safePe?: boolean = false;
  wifiSecurity?: boolean = false;
}

export class DesktopSecurityFeatureDto {
  deviceId?: string | null = '';
  desktopSettingType?: any;
  systemRequestType?: string = '';
  requestType?: string = '';
  ransomwareProtection?: boolean = false;
  virusProtection?: boolean = false;
  firewallProtection?: boolean = false;
  idsIpsProtection?: boolean = false;
  virusProtectionOnValue?: number = 0;
  ransomewareProtectionOnValue?: number = 0;
}

export class ScanSecurityFeatureDto {
  deviceId?: string = '';
  date?: any = null;
  dayOfWeek?: any = null;
  qurantinedFrequencyType?: any = null;
  scanFrequencyType?: any = null;
  time?: any = null;
}

//Anti Theft - Setting
export class AntiTheftDto {
  deviceId?: string = '';
  antiTheftSettingsOn?: boolean = false;
  blockOnAirPlaneMode?: boolean = false;
  primaryContactNumber?: string = '';
  secondaryContactNumber?: string = '';
  intruderAlertSettingsOn?: boolean = false;
}

export class ParentalControlDto {
  deviceId?: string = '';
  preventAppInstallaion?: boolean = false;
  useCustomBrowser?: boolean = false;
  parentalCntrl?: boolean = false;
  restrictCategoryList?: [] = [];
  excludedWebsiteList?: any;
  blockAppCategoryList?: [] = [];
  allowedPrntBrowserList?: [] = [];
  blockParticularWebsiteList?: any;
  allowedAppsList?: [] = [];
  webSecurityOn?: boolean = false;
  licenseStatus?: string = '';
}
export class YoutubeControlDTO {
  deviceId?: string = '';
  isEnable?: boolean = false;
  blockShort?: boolean = false;
  blockedCategories: string[] = [];
  blockedVideos: string[] = [];
  blockedChannels: string[] = []; // Explicitly define as string[]
  blockedKeywords: string[] = [];
  allowedChannels: string[] = [];
  allowedVideos: string[] = [];
}

export class SendCommandDto {
  deviceId?: string | null = '';
  requestType?: string = '';
  mobileNo?: string = '';
  productKeyType?: string = '';
  systemRequestType?: string = '';
  settingFailureTypes?: string = '';
}

export class SendSettingStatusDto {
  deviceId?: string | null = '';
  productKeyType?: string = '';
}
export class ActivityHistoryDto {
  searchKey?: string = '';
  filterKey?: string = '';
  statusList?: any;
  actionList?: any;
  fromDate?: string = '';
  toDate?: string = '';
  pageNumber?: number;
  pageSize?: number;
  sort?: string = 'DESC';
  fieldToSort?: string = 'date';
  field?: string = '';
  userIdsList?: [] = [];
  deviceId?: string = '';
  userId?: string = '';
  locationFilterType?: string = '';
}
export class actionList {
  public action: string;
}
export class statusList {
  public status: string;
}
export class LocationHistoryDto {
  searchKey?: string = '';
  filterKey?: string = '';
  fromDate?: string = '';
  toDate?: string = '';
  pageNumber?: number;
  pageSize?: number;
  sort?: string = 'DESC';
  fieldToSort?: string = 'date';
  field?: string = '';
  userIdsList?: [] = [];
  deviceId?: string = '';
  userId?: string = '';
  locationFilterType?: string = '';
  traceOperation: number;
  isChecked: boolean = false;
}

export class SystemParentalDto {
  user?: string = '';
  configured?: boolean = false;
  webCatList?: [] = [];
  blockWebsites?: [] = [];
  excludeWebsites?: [] = [];
  appCategoryList?: [] = [];
  blockApplications?: [] = [];
  excludeApplications?: [] = [];
  pcAccessaccessToInternet?: string;
  pcAccessscheduleSelection?: number;
  accessToInternet?: [] = [];
  InteAccesstimeSlots?: any;
  scheduleType?: any;
  allWebChecked?: boolean = false;
  allAppChecked?: boolean = false;
  timeSlots?: {} = {};
  hoursSlot?: [] = [];
}

export class SystemParentalPayload {
  parenatlSettingList: SystemParentalDto[] = [];
  applyTo?: number;
  systemIds: [] = [];
  isParentalControlOn?: boolean = true;
  isAllUsersConfigured?: boolean = false;
}

export class OtherDeviceSettings {
  deviceId: string;
  otherDevices: [] = [];
  requestType: string;
  systemRequestType: string;
  deviceType: string;
}

